/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Link } from '@atoms';
import { Form } from '@organisms';
import { COL_WITH_EXTRA } from '@constants';
import ROUTES from '@constants/routes';

import RegionSelect from '../RegionSelect';

const RegionField = React.forwardRef(
  (
    {
      initialRegion,
      wrapperCol,
      disabled,
      onChange,
      onSearch,
      showAction,
      placeholder,
      queryVariables,
      value,
      ...props
    },
    ref,
  ) => {
    const [selectedRegion, setSelectedRegion] = React.useState(initialRegion);

    const handleChange = (region) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(region);
      setSelectedRegion(region);
    };

    return (
      <>
        <Form.WithFieldValue name={props.name}>
          {(_value) => {
            if (!_value) {
              setSelectedRegion(undefined);
            }
          }}
        </Form.WithFieldValue>
        <Form.ItemWithExtra
          wrapperCol={{ ...COL_WITH_EXTRA, ...wrapperCol }}
          extra={
            !!selectedRegion && (
              <Link to={`/${ROUTES.MINISITES}/${selectedRegion.id}`} target="_blank" rel="noopener noreferrer">
                Region setup
              </Link>
            )
          }
          {...props}
        >
          <RegionSelect
            value={value}
            ref={ref}
            onChange={handleChange}
            disabled={disabled}
            onSearch={onSearch}
            showAction={showAction}
            placeholder={placeholder}
            queryVariables={queryVariables}
          />
        </Form.ItemWithExtra>
      </>
    );
  },
);

export default RegionField;
